import { __decorate, __metadata } from "tslib";
import { Vue, Component, Inject } from 'vue-property-decorator';
let PolicyFooterImpl = class PolicyFooterImpl extends Vue {
    get href() {
        return this.commonService.globalData?.official_privacy_url;
    }
    onClose() {
        this.$emit('close');
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], PolicyFooterImpl.prototype, "commonService", void 0);
PolicyFooterImpl = __decorate([
    Component({
        name: 'PolicyFooter',
    })
], PolicyFooterImpl);
export { PolicyFooterImpl };
